/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import { SchoolReportStatusCssClasses, SchoolReportStatusTitles } from "../../../../../../../_helpers/Helpers";

export const StatusColumnFormatter = (cellContent, row) => (
  <span
    className={`label label-lg label-light-${
      SchoolReportStatusCssClasses[row.reportStatus]
    } label-inline`}
  >
    {SchoolReportStatusTitles[row.reportStatus]}
  </span>
);